<template>
  <div v-if="isOTCSalesChannel" class="catalog-otc-filters">
    <Button
      v-for="branch in branches"
      :key="branch.id"
      :modifiers="[
        'small',
        String(active) === String(branch.id) ? 'primary' : 'secondary',
      ]"
      :on-click="() => click(branch.id)"
    >
      F{{ branch.id }} ({{ branch.name }})
    </Button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Button from 'Components/01-atoms/button/Button.vue';

export default {
  name: 'CatalogOtcFilters',
  components: {
    Button,
  },
  props: {
    active: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      branches: [
        { id: 0, name: 'NSD+LUD' },
        { id: 1, name: 'Weißensee' },
        { id: 2, name: 'Mahlsdorf' },
        { id: 3, name: 'Spandau' },
      ],
    };
  },
  computed: {
    ...mapGetters('core', ['isOTCSalesChannel']),
  },
  methods: {
    click(value) {
      if (String(this.active) === String(value)) {
        this.$emit('onSelect', null);
        return;
      }
      this.$emit('onSelect', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-otc-filters {
  padding-bottom: var(--space-1--half);

  button {
    margin-right: var(--space-0--half);
  }
}
</style>
